var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRelation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4329_8183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.38676 4.08811C8.41613 3.89318 7.40832 4.02373 6.5194 4.45954C5.63048 4.89535 4.91006 5.6121 4.46971 6.49878C4.02937 7.38547 3.89367 8.3926 4.08364 9.36421C4.27361 10.3358 4.77864 11.2177 5.52051 11.8732C6.26239 12.5288 7.19972 12.9214 8.18732 12.9903C9.17492 13.0592 10.1577 12.8006 10.9834 12.2544C11.8092 11.7083 12.4318 10.9051 12.7548 9.96929C13.0779 9.03348 13.0834 8.01726 12.7705 7.07801",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6071 12.9144C14.5788 13.1103 15.5879 12.98 16.4779 12.5436C17.3679 12.1073 18.089 11.3893 18.5292 10.5012C18.9694 9.61311 19.104 8.60453 18.9123 7.63204C18.7206 6.65956 18.2132 5.77756 17.4689 5.12297C16.7246 4.46839 15.785 4.07782 14.796 4.01192C13.8069 3.94601 12.8238 4.20844 11.9992 4.75848C11.1746 5.30852 10.5547 6.11539 10.2356 7.05384C9.91657 7.99229 9.91624 9.00982 10.2347 9.94848",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4329_8183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelation);
export default __webpack_public_path__ + "static/media/Relation.517f86beb4eeabe97eb03eb50686d6a8.svg";
export { ForwardRef as ReactComponent };